module.exports = __webpack_public_path__ + "img/snowflake.3a8644c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/snowflake.png
// module id = FMke
// module chunks = 39 44